import { client } from "api";
import { Company } from "models/Company";

export type UnblockCompanyRequest = {
  companyId: string;
  reason?: string;
};

export type UnblockCompanyResponse = Company;

export const unblockCompany = ({ companyId, reason }: UnblockCompanyRequest) =>
  client.post<UnblockCompanyResponse>(`/company/${companyId}/unblock`, { reason }).then((res) => res.data);
